import { useNavigate } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import styles from "./ProviderDashboard.module.css";

const NewClientsCard = ({
  clients = [],
  count = 0,
  isLoading = false,
}) => {
  const navigate = useNavigate();
  const hasClients = clients.length > 0;

  const openClientProfile = (client) => {
    navigate(`/clients/${client.id}`, {
      state: {
        client: {
          _id: client.id,
          id: client.id,
          name: client.patientName,
        },
      },
    });
  };

  return (
    <section className={styles.widget}>
      <div className={styles.widgetHeaderWithBadge}>
        <div className={`${styles.widgetTitleGroup} ${styles.widgetTitleGroupWithSubtitle}`}>
          <FaUsers className={styles.widgetIcon} aria-hidden />
          <div className={styles.widgetTitleBlock}>
            <h2 className={styles.widgetTitle}>New Clients</h2>
            <p className={styles.widgetSubtitle}>Pending intake</p>
          </div>
        </div>
        {!isLoading && count > 0 ? (
          <span className={styles.badge}>{count}</span>
        ) : null}
      </div>

      <div className={styles.widgetBody}>
        {isLoading ? (
          <p className={styles.loadingState}>Loading clients...</p>
        ) : hasClients ? (
          clients.map((client) => (
            <button
              type="button"
              className={styles.clientCardButton}
              key={client.id}
              onClick={() => openClientProfile(client)}
            >
              <span className={styles.avatar}>{client.initials}</span>
              <div className={styles.cardContent}>
                <p className={styles.patientName}>{client.patientName}</p>
                <p className={styles.cardMeta}>{client.scheduledLabel}</p>
              </div>
              <span className={styles.intakePill}>Pending intake</span>
            </button>
          ))
        ) : (
          <div className={styles.scheduleEmptyState}>
            <p className={styles.emptyStateMessage}>
              No new clients pending intake.
            </p>
            <button
              type="button"
              className={styles.emptyStateAction}
              onClick={() => navigate("/clients")}
            >
              View Clients
            </button>
          </div>
        )}
      </div>

      <div className={styles.widgetFooter}>
        <button
          type="button"
          className={styles.ctaLink}
          onClick={() => navigate("/clients")}
        >
          View All Clients
          <span className={styles.ctaArrow}>→</span>
        </button>
      </div>
    </section>
  );
};

export default NewClientsCard;
